export default __webpack_public_path__ + "static/media/adrian-story.daf50189.png";